var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeWidth: "1px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42699 8.30984H17.4287M7.42699 11.97H13.4242M6.81599 16.9829H19.6231C20.337 16.9829 20.9231 16.415 20.9231 15.7233V5.25953C20.9231 4.56789 20.337 4 19.6231 4H5.2231C4.50924 4 3.9231 4.56789 3.9231 5.25953V19.7857L6.81599 16.9829Z",
    stroke: "#2D4C5D"
  })));
};
export default SvgChat;